import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ZoomOptionModel } from './zoom-option.model';

@Component({
  selector: 'app-zoom-option',
  templateUrl: './zoom-option.component.html',
  styleUrls: ['./zoom-option.component.scss']
})
export class ZoomOptionComponent implements OnInit {

  constructor() { }

  public model: any = new ZoomOptionModel();
  public zoomLevel = 1;
  @Input() showZoomOpt: boolean;
  @Output() zoom: EventEmitter<number> = new EventEmitter<number>();
  ngOnInit() {
  }

  public passZoomLevel(zoomLevel: number){
    this.zoom.emit(zoomLevel);
  }

}
